export const keywordsSlugRegex = /(?<=\/)[^\/]+(?=-jobs(?:\/|$))/;

export function replaceKeywordsSlugPath(url: string, newSlug: string): string {
  const normalised = newSlug.trim().replace(/\s+/g, ' ').replace(/ /g, '-');
  return url.replace(keywordsSlugRegex, normalised);
}
